import { BaseWebComponentView } from '../../../../framework/BaseWebComponentView';
import { GzToggleWebComponent } from '../../../../ui/gzToggle';
import { GzRadioGroupWebComponent, GzRadioWebComponent } from '../../../../ui/gzRadio';
import { TemplateState } from '../../../../types/common/types';
import { FormGroup } from '../../../../ui/gzForm/formGroup/form-group';
import { GzHardCodedFormField } from '../../../../ui/gzForm/formField/component/GzHardCodedFormField';
import { Feature } from '@nirvana/shared/constants';
import { MdrServiceFlavor } from '../../../types/MdrServiceFlavor';
import { BaseWebComponentTranslator } from '../../../../framework/BaseWebComponentTranslator';
import { ProductServiceStatus } from '../../../types/ProductServiceStatus';
import { GzTextWebComponent } from 'apps/webcomponents/src/index.ui';
import { LicenseRenderers } from 'apps/webcomponents/src/company/common/licenseRenderers/LicenseRenderers';
import { getStatusWithBullet } from '../../../../company/common/licensingTab/MdrUtils';
import { htmlEncode } from '../../../../utils/escape.utils';

export class LicenseMonthlyServicesFormView extends BaseWebComponentView {
  private translator: BaseWebComponentTranslator;

  public mdrAdviceUsable = Feature.getFeatureFlag(Feature.PRODUCT_FEATURE_MDR_ADVICE_USABLE);
  public formGroup!: FormGroup;

  public mdrAdviceFormField: GzHardCodedFormField<boolean>;

  public dom: {
    $wrapper: HTMLElement;

    $managedDetectionAndResponseToggle: GzToggleWebComponent;
    $parentCompanyMdrContactInfoRequired: GzTextWebComponent;
    $managedDetectionAndResponseServiceStatus: HTMLElement;
    $managedDetectionAndResponseFlavours: GzRadioGroupWebComponent;
    $mdrAdviceFlavour: GzRadioWebComponent;
    $mdrInTrialText: HTMLElement;
  };

  getDomElements() {
    this.dom = {
      $wrapper: this.shadow.querySelector('#wrapper'),
      $managedDetectionAndResponseToggle: this.shadow.querySelector(
        '#additional-managed-detection-and-response-form-field'
      ),
      $managedDetectionAndResponseServiceStatus: this.shadow.querySelector(
        '#managed-detection-and-response-service-status'
      ),
      $managedDetectionAndResponseFlavours: this.shadow.querySelector('#mdr-advice-flavours-group'),
      $mdrAdviceFlavour: this.shadow.querySelector('#mdr-advice-form-field'),
      $parentCompanyMdrContactInfoRequired: this.shadow.querySelector(
        '#service-parent-company-mdr-contact-info-required'
      ),
      $mdrInTrialText: this.shadow.querySelector('#mdr-trial-started-text'),
    };

    this.getTranslations();
    this.setTranslatedStrings();
  }

  getTranslations() {
    this.translator = BaseWebComponentTranslator.getInstance();
    this.translations = this.stringsTranslator.getMdrTranslations();

    return this.translations;
  }

  setTranslatedStrings() {
    this.dom.$managedDetectionAndResponseToggle.textContent = this.translations.mdrServiceName;

    this.dom.$mdrAdviceFlavour.label = this.translator.getTranslatedMdrFlavor(MdrServiceFlavor.FOUNDATIONS);
    this.dom.$parentCompanyMdrContactInfoRequired.innerText = LicenseRenderers.getParentCompanyMdrContactInfoRequired();
    this.dom.$mdrInTrialText.textContent = this.translator.translateFn('Trial started');
  }

  public showMdrStatus(status: ProductServiceStatus) {
    this.dom.$managedDetectionAndResponseServiceStatus.hidden = false;

    const { bullet, mdrStatusText } = getStatusWithBullet(status);

    this.dom.$managedDetectionAndResponseServiceStatus.innerHTML = `
      <gz-text class='has-bullet ${bullet}' fontSize='13'>
        ${htmlEncode(this.dependencies.translateFn("{MDR_SERVICE} Status:", { MDR_SERVICE: "MDR" }) + " " + mdrStatusText)}
      </gz-text>
    `;
  }

  private initRadios(): void {
    this.dom.$mdrAdviceFlavour.value = this.mdrAdviceUsable;
  }

  private createFormGroup() {
    const isMdrAdvice = this.dom.$managedDetectionAndResponseFlavours.selectedOption === this.mdrAdviceUsable;

    this.mdrAdviceFormField = new GzHardCodedFormField<boolean>(isMdrAdvice);

    this.formGroup = FormGroup.build({
      mdrAdviceUsable: this.mdrAdviceFormField,
    });
  }

  buildSuccessView(data: unknown) {
    this.initRadios();
    this.createFormGroup();
  }

  buildErrorView(error: Error) {
    this.resetTemplateState(this.dom.$wrapper);
    this.setTemplateState(this.dom.$wrapper, TemplateState.ERROR);
  }
}
